import { Stack, Tag, Text } from '@pairy/pds-react';

import FeatureRow from './FeatureRow';
import { PLAN_COLUMNS, PLAN_FEATURE_MATRIX } from './index.constants';
import { PlanFeatureMatrixProps } from './index.types';
import * as Styled from './index.styles';

const PlanFeatureMatrix = ({ highlightedPlan }: PlanFeatureMatrixProps) => {
  return (
    <Styled.ScrollArea>
      <Styled.Table>
        <thead>
          <tr>
            <Styled.HeadCornerCell scope="col">
              <Text variant="sm-semibold" color="zinc_500">
                기능
              </Text>
            </Styled.HeadCornerCell>

            {PLAN_COLUMNS.map((plan) => {
              const isHighlighted = plan === highlightedPlan;

              return (
                <Styled.HeadCell
                  key={plan}
                  scope="col"
                  className={isHighlighted ? 'is-highlighted' : ''}
                >
                  <Stack
                    gap={4}
                    direction="column"
                    justifyContent="center"
                    alignItems="center"
                  >
                    <Text
                      variant="md-semibold"
                      color={isHighlighted ? 'skyblue_600' : 'black'}
                    >
                      {plan}
                    </Text>
                    {isHighlighted && (
                      <Tag variant="skyblue_50" textVariant="sm-medium">
                        선택한 플랜
                      </Tag>
                    )}
                  </Stack>
                </Styled.HeadCell>
              );
            })}
          </tr>
        </thead>

        {PLAN_FEATURE_MATRIX.map((category) => (
          <tbody key={category.id}>
            <tr>
              <Styled.CategoryHeadCell scope="colgroup" colSpan={5}>
                <Stack gap={8} alignItems="center">
                  <Text variant="md-semibold" color="zinc_700">
                    {category.title}
                  </Text>
                  {category.badge && (
                    <Tag variant="loyalblue_50" textVariant="sm-medium">
                      {category.badge}
                    </Tag>
                  )}
                </Stack>
              </Styled.CategoryHeadCell>
            </tr>

            {category.rows.map((row) => (
              <FeatureRow
                key={row.id}
                row={row}
                highlightedPlan={highlightedPlan}
              />
            ))}
          </tbody>
        ))}
      </Styled.Table>
    </Styled.ScrollArea>
  );
};

export default PlanFeatureMatrix;
